/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserLocationDto } from './userLocationDto';
import { LocationHierarchyFilterDto } from './locationHierarchyFilterDto';
import { GeoLocationEntity } from './geoLocationEntity';
import { FilterDate } from './filterDate';


export interface FilterEventDto { 
    /**
     * radius = city + distance (default); hierarchy = containment
     */
    searchMode?: FilterEventDto.SearchModeEnum;
    hierarchy?: LocationHierarchyFilterDto;
    dates?: Array<FilterDate>;
    date?: FilterDate;
    location?: GeoLocationEntity;
    radiusMeter?: number;
    /**
     * True when radiusMeter is the default: the search widens it until it finds enough activities
     */
    widenRadius?: boolean;
    userLocation?: UserLocationDto;
    level?: number;
    sportIds?: Array<string>;
    minDistance?: number;
    maxDistance?: number;
    minDuration?: number;
    maxDuration?: number;
    notJoined?: boolean;
    notFromMe?: boolean;
    handiFriendlyOnly?: boolean;
    /**
     * True for the « Partenaires » link of the explore page: only brand partner events
     */
    partnersOnly?: boolean;
    accountId?: string;
    includeOnlyMyLevel?: boolean;
    /**
     * all, near (my level ±1) or exact
     */
    levelFilter?: FilterEventDto.LevelFilterEnum;
    /**
     * Keep the activities open to every level (default true)
     */
    keepAnyLevel?: boolean;
    /**
     * recommended (default), distance or date
     */
    searchOrder?: FilterEventDto.SearchOrderEnum;
    type?: string;
    status?: string;
}
export namespace FilterEventDto {
    export type LevelFilterEnum = 'all' | 'near' | 'exact';
    export const LevelFilterEnum = {
        All: 'all' as LevelFilterEnum,
        Near: 'near' as LevelFilterEnum,
        Exact: 'exact' as LevelFilterEnum
    };
    export type SearchOrderEnum = 'recommended' | 'distance' | 'date';
    export const SearchOrderEnum = {
        Recommended: 'recommended' as SearchOrderEnum,
        Distance: 'distance' as SearchOrderEnum,
        Date: 'date' as SearchOrderEnum
    };
    export type SearchModeEnum = 'radius' | 'hierarchy';
    export const SearchModeEnum = {
        Radius: 'radius' as SearchModeEnum,
        Hierarchy: 'hierarchy' as SearchModeEnum
    };
}


